import { Injectable } from "@angular/core";
import {Adapter} from "./adapter"
import { Team, TeamAdapter } from "./team";
import { Skill } from "./skill";
import { People, PeopleAdapter } from "./people";

export class Role {
    
    public peoples: People[] = [];
    public associatedTeams: { team: Team, requiredFte: number }[] = [];

    constructor(
        public id: number,
        public name: string, 
        public description: string, 
        public createdAt: Date, 
        public updatedAt: Date | null
        ) {}
}

@Injectable({
    providedIn: "root",
})

export class RoleAdapter implements Adapter<Role> {

    constructor(private peopleAdapter: PeopleAdapter,
                private teamAdapter: TeamAdapter,    
    ) { }

    adapt(item: any): Role {

        const updatedAt = item.updated_at ? new Date(item.updated_at) : null;

        let role = new Role(item.id, item.name, item.description, new Date(item.created_at), updatedAt);
        
        if(item.peoples) {
            const self = this;
            role.peoples = item.peoples.map(
                (people: People)  => this.peopleAdapter.adapt(people)
            );
        }

        if (item.team_requirements) {
            role.associatedTeams = item.team_requirements.map(
                (req: any) => ({ 
                    team: this.teamAdapter.adapt(req.team), 
                    requiredFte: req.required_fte 
                })
            );
        }
        
        return role 
    }

    adaptToApi(role: Role): any {
        return {
            name: role.name,
            description: role.description,
            created_at: role.createdAt,
            updated_at: role.updatedAt
        }
    }
}